/**
 * Grand Quack Auto — dynamic news ticker.
 *
 * CNN/Fox-style scrolling chyron narrating duck crimes in real-time.
 * Per virality2.md: "players will screenshot the funniest headlines
 * and post them without any editing needed."
 */

import { getTotalScared } from '../systems/npcSystem';
import type { World } from '../types';

const TEMPLATES = [
  'BREAKING: Rubber duck causes chaos, {scared} pedestrians traumatized so far',
  'ALERT: Citizens urged to stay indoors as duck crime wave continues',
  'EXPERT: "We\'ve never seen a duck this dangerous"',
  'DEVELOPING: Property damage estimated at {chaos} duck-dollars',
  'WITNESSES: "It just... quacked at everyone and they FLEW"',
  'POLL: Should ducks be allowed in public? 97% say NO',
  'LOCAL MAN: "I thought it was a bath toy. I was wrong."',
  'SCIENCE: Researchers confirm duck quacks DO echo, violently',
  'ECONOMY: Insurance companies refusing to cover "duck incidents"',
  'SPORTS: Duck outpaces police cruiser in downtown chase',
  'OPINION: This is what happens when we defund duck control',
  'WEATHER: Forecast calls for scattered quacks with a chance of chaos',
];

let tickerEl: HTMLElement | null = null;
let lastHeadline = '';
let lastUpdateChaos = 0;

export function initNewsTicker(): void {
  const hud = document.getElementById('hud');
  if (!hud) return;

  tickerEl = document.createElement('div');
  tickerEl.id = 'news-ticker';
  tickerEl.innerHTML = '<span id="ticker-text">QUACK NEWS NETWORK — Standing by...</span>';
  hud.appendChild(tickerEl);
}

export function updateTicker(world: World): void {
  if (!tickerEl) return;

  // Update every 15 chaos points change or 10 seconds.
  const chaosDelta = Math.abs(world.chaos.points - lastUpdateChaos);
  if (chaosDelta < 15) return;
  lastUpdateChaos = world.chaos.points;

  const scared = getTotalScared();
  const chaos = Math.floor(world.chaos.points);

  // Pick a random template (avoid repeats).
  let headline = '';
  for (let i = 0; i < 5; i++) {
    const t = TEMPLATES[Math.floor(Math.random() * TEMPLATES.length)]!;
    headline = t.replace('{scared}', String(scared)).replace('{chaos}', String(chaos));
    if (headline !== lastHeadline) break;
  }
  lastHeadline = headline;

  const textEl = document.getElementById('ticker-text');
  if (textEl) textEl.textContent = `QUACK NEWS NETWORK — ${headline}`;
}
